import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import { Box } from '@/components/blocks/Box';
import { Flex } from '@/components/blocks/Flex';
import { Footer } from '@/components/layouts/SharedAppShell/Footer';
import { Header } from '@/components/layouts/SharedAppShell/Header';
interface Props {
  children: ReactNode;
}

const Root = styled(Flex)(({ theme }) =>
  css({
    maxWidth: '640px',
    [`@media ${theme.mediaQueries.portrait}`]: {
      maxWidth: '100%',
    },
    [`@media ${theme.mediaQueries.landscape}`]: {
      maxWidth: '100%',
    },
    [`@media ${theme.mediaQueries.tablet}`]: {
      maxWidth: '100%',
    },
    [`@media ${theme.mediaQueries.pc}`]: {
      maxWidth: '100%',
    },
    position: 'relative',
    margin: '0 auto',
    height: '100dvh',
    WebkitOverflowScrolling: 'touch',
    flexDirection: 'column',
  })
);

const ContentArea = styled(Box)(() =>
  css({
    flex: 1,
  })
);

export const SharedAppShell = (props: Props) => {
  return (
    <Root>
      <Header />
      <ContentArea>{props.children}</ContentArea>
      <Footer />
    </Root>
  );
};
